module.exports = __webpack_public_path__ + "static/img/2_2_2.41c762bd.jpg";